import "./more-about-me.styles.scss";

const MoreAboutMe = () => {
  return (
    <div className="more-about-me">
      <div className="more-about-me-container">More About Me</div>
    </div>
  );
};

export default MoreAboutMe;
